import React, { Component } from 'react'
import styled from 'styled-components'
import {
  SelectBox,
  PageWrapper,
  XLText,
  DefaultText,
  FlexWrapper,
  StyledSlider,
  Card,
  Button,
  XMText,
  Icon,
  Arrow,
  FormikForm,
  StyledImage,
  Input,
  Header,
  CustomSlider,
  XMTDFext
} from '../components'
import { get, find, isEmpty, endsWith, startsWith, lowerCase, uniqBy, replace } from 'lodash'
import { Formik, Field } from 'formik'
import axios from 'axios'
import { API_URL } from '../constants'
import Cookies from 'js-cookie'
import qs from 'qs'
import { zipCodeValidator } from '../utlis/validators'
// import { calColor } from '../utlis/functions'

const StepperWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 20px 0 40px;
`
/* const Step = styled.div`
  width: 36px;
  height: 10px;
  background: ${props => (props.active ? '#124b5f' : 'rgba(18, 75, 95, 0.15)')};
  border-radius: 20px;
  margin-right: 5px;
` */
const CountWrap = styled.div`
  border-radius: 18px;
  background-color: #ffffff;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 4px; */
  margin-right: 6px;
  min-width: 26px;
  border: 1px solid ${props => (props.borderColor ? props.borderColor : 'transparent')};
`

/* const CheckMark = styled.div`
  display: inline-block;

  &:after {
    content: '';
    display: block;
    width: 3px;
    height: 8px;
    border: solid #078489;
    border-width: 0 1.5px 1.5px 0;
    transform: rotate(45deg);
  }
` */
const FlexModified = styled(FlexWrapper)`
  overflow: auto;
  align-content: baseline;
  padding-bottom: ${props => (props.paddingBottom ? props.paddingBottom : '60px')};
`
const cardTitle = [
  'processing',
  'nutrition',
  'food safety',
  'animal welfare',
  'environment',
  'human rights',
  'transparency'
]

class Dashboard extends Component {
  state = {
    horizontal: {},
    cardIndex: 0,
    selected: [],
    selectedAllergy: [],
    selectedDislikes: [],
    selectedShops: [],
    isLoading: false,
    touched: {},
    dietsData: [],
    allergiesData: [],
    dislikesData: [],
    shops: [],
    dynamicAllergies: '',
    allergy: '',
    dislikes: '',
    error: '',
    zipcode: '',
    isSafari: false
  }
  componentDidMount = async () => {
    if (navigator.userAgent.indexOf('Safari') !== -1) {
      this.setState({ isSafari: true })
    }
    const productCode = get(this.props, 'location.state.productCode', '')
    this.setState({ productCode })
    try {
      const { data } = await axios.get(`${API_URL}/Diets?filter={"priority": 1}`)
      await this.setState({ isLoading: false })
      this.setState({ dietsData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
    try {
      const { data } = await axios.get(`${API_URL}/Allergies?filter={"priority": 1,"limit": "6"}`)
      await this.setState({ isLoading: false })
      this.setState({ allergiesData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
    /*  try {
      const { data } = await axios.get(`${API_URL}/Dislikes?filter={"priority": 1}`)
      await this.setState({ isLoading: false })
      this.setState({ dislikesData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    } */
    try {
      const { data } = await axios.get(`${API_URL}/Grocers`)
      await this.setState({ isLoading: false })

      const filteredData = data.map(item => {
        const storeNameR = lowerCase(replace(item.storeName, 'Insta_', ''))
        return {
          storeName: storeNameR,
          zipCode: item.zipCode,
          imageUrl: item.imageUrl,
          grocerType: item.grocerType
        }
      })
      this.setState({ shops: uniqBy(filteredData, 'storeName') })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
    await this.fetchUserDetails()
    this.addedGrocers()
  }

  addedGrocers = async () => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id') }
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserGrocers?${qs.stringify(query)}`)
      this.setState({ selectedShops: data.map(item => item.storeName) })
    } catch (error) {
      console.log(error)
    }
  }

  //fetching user details
  fetchUserDetails = async () => {
    const query = {
      filter: {
        include: ['dislikes', 'allergies', 'grocers', 'diets']
      }
    }

    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}?access_token=${Cookies.get('access_token')}&${qs.stringify(query)}`
      )
      this.setState({
        selected: data.diets.map(item => item.id),
        selectedAllergy: data.allergies.map(item => item.id),
        selectedDislikes: data.dislikes.map(item => item.id),
        zipcode: data.zipCode,
        horizontal: {
          processing: data.gsCategoryWeightProcessing,
          nutrition: data.gsCategoryWeightNutrition,
          'food safety': data.gsCategoryWeightFoodSafety,
          'animal welfare': data.gsCategoryWeightAnimalWelfare,
          environment: data.gsCategoryWeightEnvironment,
          'human rights': data.gsCategoryWeightHumanRights,
          transparency: data.gsCategoryWeightTransparency
        }
      })
      // console.log('this.state.selectedAllergy==>', this.state.selectedAllergy)
      await Cookies.set('userDetails', data, { path: '/', expires: 365 })
      if (isEmpty(data.status.user.stage)) {
        return null
      } else {
        this.props.history.push(`${data.status.user.stage}`)
      }
    } catch (error) {
      // console.log('ERROR', get(error.response, 'data.error.message', ''))
    }
  }

  // handling chip selection
  chipHandler = e => {
    this.setState({ touched: { ...this.state.touched, dietsTouched: true } })
    const selectedChip = this.state.selected
    const res = find(selectedChip, o => o === e)
    if (res !== e) {
      selectedChip.push(e)
      this.setState({ selected: selectedChip })
    } else {
      //toggle the chip selection
      const result = selectedChip.filter(o => o !== res)
      this.setState({ selected: result })
    }
  }
  allergyChipHandler = e => {
    this.setState({ touched: { ...this.state.touched, allegiesTouched: true } })
    const selectedChip = this.state.selectedAllergy
    const res = find(selectedChip, o => o === e)
    if (res !== e) {
      selectedChip.push(e)
      this.setState({ selectedAllergy: selectedChip })
    } else {
      //toggle the chip selection
      const result = selectedChip.filter(o => o !== res)
      this.setState({ selectedAllergy: result })
    }
  }
  /* dislikesChipHandler = e => {
    const selectedChip = this.state.selectedDislikes
    const res = find(selectedChip, o => o === e)
    if (res !== e) {
      selectedChip.push(e)
      this.setState({ selectedDislikes: selectedChip })
    } else {
      //toggle the chip selection
      const result = selectedChip.filter(o => o !== res)
      this.setState({ selectedDislikes: result })
    }
  } */
  shopsChipHandler = e => {
    this.setState({ touched: { ...this.state.touched, shopsTouched: true } })
    const selectedChip = this.state.selectedShops
    // console.log('selectedChip', selectedChip)
    const res = find(selectedChip, o => o === e)
    if (res !== e) {
      selectedChip.push(e)
      this.setState({ selectedShops: selectedChip })
    } else {
      //toggle the chip selection
      const result = selectedChip.filter(o => o !== res)
      this.setState({ selectedShops: result })
    }
  }

  handleMyValues = async () => {
    this.setState({ isLoading: true })
    try {
      await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
        gsCategoryWeightProcessing: this.state.horizontal.processing || 0,
        gsCategoryWeightNutrition: this.state.horizontal.nutrition || 0,
        gsCategoryWeightFoodSafety: this.state.horizontal['food safety'] || 0,
        gsCategoryWeightAnimalWelfare: this.state.horizontal['animal welfare'] || 0,
        gsCategoryWeightHumanRights: this.state.horizontal['human rights'] || 0,
        gsCategoryWeightEnvironment: this.state.horizontal.environment || 0,
        gsCategoryWeightTransparency: this.state.horizontal.transparency || 0
      })
      await this.setState({ isLoading: false })
      this.props.history.goBack()
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }
  // handling range slider
  handleChangeHorizontal = (value, cardIndex) => {
    this.setState({
      horizontal: { ...this.state.horizontal, [cardIndex]: value * 10 },
      touched: { ...this.state.touched, valuesTouched: true }
    })
  }

  handleDietaryPreference = async () => {
    const dietaryData = this.state.selected.map(item => ({
      dietId: item,
      userId: Cookies.get('user_id')
    }))
    this.setState({ isLoading: true })
    try {
      await axios.delete(`${API_URL}/users/${Cookies.get('user_id')}/diets`)
      await axios.post(`${API_URL}/UserDiets`, dietaryData)
      await this.setState({ isLoading: false })
      this.props.history.push('/dashboard/allergies')
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }

  handleAllergies = async () => {
    const allergiesData = this.state.selectedAllergy.map(item => ({
      allergyId: item,
      userId: Cookies.get('user_id')
    }))
    console.log('allergiesData', allergiesData)
    this.setState({ isLoading: true })
    try {
      await axios.delete(`${API_URL}/users/${Cookies.get('user_id')}/allergies`)
      const { data } = await axios.post(`${API_URL}/UserAllergies`, allergiesData)
      console.log('DATA', data)
      await this.setState({ isLoading: false })
      if (!isEmpty(this.state.productCode)) {
        this.props.history.replace(`/products/${this.state.productCode}/green-score`)
      }
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }
  /* handleDislikes = async () => {
    const allergiesData = this.state.selectedDislikes.map(item => ({
      dislikeId: item,
      userId: Cookies.get('user_id')
    }))
    console.log('this.state.selectedDislikes', this.state.selectedDislikes)
    this.setState({ isLoading: true })
    await axios.delete(`${API_URL}/users/${Cookies.get('user_id')}/dislikes`)
    try {
      const { data } = await axios.post(`${API_URL}/UserDislikes`, allergiesData)
      console.log('DATA', data)
      await this.setState({ isLoading: false })
      await Cookies.set('steps', {
        values: true,
        'dietary-preference': true,
        allergies: true,
        dislikes: true,
        zipcode: false,
        shop: false
      })
      await this.setCompletedStage('/dashboard/dislikes')
      this.props.history.push('/dashboard/zipcode')
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  } */

  handleZipcode = async values => {
    this.setState({ isLoading: true })
    try {
      await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
        zipCode: values.zipcode
      })
      await this.setState({ isLoading: false })
      const userDetails = await Cookies.getJSON('userDetails')
      const newUserDetails = { ...userDetails, zipCode: values.zipcode }
      // Cookies.remove('userDetails', { path: '/' })
      await Cookies.set('userDetails', newUserDetails, { path: '/', expires: 365 })
      this.props.history.goBack()
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }

  handleShops = async () => {
    const shopsData = this.state.selectedShops.map(item => ({
      storeName: item,
      userId: Cookies.get('user_id')
    }))
    this.setState({ isLoading: true })
    await axios.delete(`${API_URL}/users/${Cookies.get('user_id')}/grocers`)
    try {
      const { data } = await axios.post(`${API_URL}/UserGrocers`, shopsData)
      console.log('DATA', data)
      await this.setState({ isLoading: false })
      this.props.history.goBack()
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }

  handleInputChange = async dynamicAllergies => {
    this.setState({ dynamicAllergies })
  }

  setCompletedStage = async (value = {}) => {
    try {
      await axios.patch(`${API_URL}/users/${Cookies.get('user_id')}`, {
        stage: value
      })
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  async fetchAsyncData(value) {
    const query = {
      filter: {
        where: {
          allergy: {
            like: '%' + value + '%'
          }
        }
      }
    }
    if (value) {
      try {
        const { data } = await axios.get(`${API_URL}/Allergies?${qs.stringify(query)}`)
        console.log('DATA', data)
        this.setState({ allergy: data })
      } catch (error) {
        console.log('ERROR', error)
      }
    }
    return this.state.allergy
  }
  async fetchDislikeData(value) {
    const query = {
      filter: {
        where: {
          name: {
            like: '%' + value + '%'
          }
        }
      }
    }
    if (value) {
      try {
        const { data } = await axios.get(`${API_URL}/Dislikes?${qs.stringify(query)}`)
        console.log('DATA', data)
        this.setState({ dislikes: data })
      } catch (error) {
        console.log('ERROR', error)
      }
    }
    return this.state.dislikes
  }

  // search filter for allergies
  loadAllergies = async inputValue => {
    try {
      const newData = await this.fetchAsyncData(inputValue)
      return newData.map(item => ({
        value: item.id,
        label: item.allergy,
        id: item.id,
        allergy: item.allergy,
        priority: item.priority,
        allergyCategory: item.allergyCategory
      }))
    } catch (err) {}
  }
  // search filter for dislikes
  loadDislikes = async inputValue => {
    try {
      const newData = await this.fetchDislikeData(inputValue)
      return newData.map(item => ({
        value: item.id,
        label: item.name,
        id: item.id,
        name: item.name,
        priority: item.priority
      }))
    } catch (err) {}
  }
  render() {
    const {
      horizontal,
      cardIndex,
      selected,
      selectedAllergy,
      // selectedDislikes,
      isLoading,
      dietsData,
      allergiesData,
      // dislikesData,
      selectedShops,
      touched,
      shops,
      zipcode,
      // isSafari,
      error
    } = this.state
    const {
      location: { pathname }
    } = this.props

    const horizontalLabels = {
      0: 'Not important',
      10: 'Very important'
    }
    const valuesData = [
      { title: 'processing', subTitle: 'Less artificial ingredients and additives', icon: 'strawberry' },
      { title: 'nutrition', subTitle: 'Maintain a healthy balanced diet', icon: 'food' },
      { title: 'food safety', subTitle: 'Avoid harmful chemicals and toxins', icon: 'shield' },
      { title: 'animal welfare', subTitle: 'Reduce the suffering of animals', icon: 'foot' },
      { title: 'environment', subTitle: 'Protect earth’s resources and wildlife', icon: 'environment' },
      { title: 'human rights', subTitle: 'Respect employees, farmers and communities', icon: 'group' },
      { title: 'transparency', subTitle: ' Companies should be honest with us', icon: 'eye' }
    ]
    return (
      <React.Fragment>
        {endsWith(pathname, '/edit') && (
          <Header
            icon="arrowBack"
            onClickBack={() => this.props.history.goBack()}
            backgroundColor="#078489"
            title={
              pathname === '/dashboard/values/edit'
                ? 'My Values'
                : pathname === '/dashboard/dietary-preference/edit'
                ? 'Dietary Preferences'
                : pathname === '/dashboard/allergies/edit'
                ? 'Allergies'
                : pathname === '/dashboard/shop/edit'
                ? 'Favorite Grocers'
                : pathname === '/dashboard/zipcode/edit'
                ? 'Zip Code'
                : ''
            }
            color="#fff"
          />
        )}
        <PageWrapper
          viewPadding={endsWith(pathname, '/edit') ? '22.4% 8% 6%' : '6% 8% 6%'}
          height={
            endsWith(pathname, 'dietary-preference/edit')
              ? '100%'
              : endsWith(pathname, 'values/edit')
              ? 'auto'
              : startsWith(pathname, '/dashboard/values')
              ? 'auto'
              : endsWith(pathname, '/edit')
              ? '100%'
              : '100%'
          }>
          {endsWith(pathname, '/edit') ? (
            ''
          ) : (
            <StepperWrapper>
              {/* <Step active={Cookies.getJSON('steps').values || pathname === '/dashboard/dietary-preference'} /> */}
              {/* <Step active={Cookies.getJSON('steps')['dietary-preference'] || pathname === '/dashboard/allergies'} /> */}
              {/* <Step active={Cookies.getJSON('steps').allergies || pathname === '/dashboard/dislikes'} /> */}
              {/* <Step active={Cookies.getJSON('steps').dislikes || pathname === '/dashboard/zipcode'} /> */}
              {/* <Step active={Cookies.getJSON('steps').zipcode || pathname === '/dashboard/shop'} />
              <Step active={Cookies.getJSON('steps').shop || pathname === '/dashboard/shop'} /> */}
              {/*   <Step active={Cookies.getJSON('steps')['dietary-preference']} />
              <Step active={Cookies.getJSON('steps')['dietary-preference']} /> */}
            </StepperWrapper>
          )}
          {pathname === '/dashboard/values/edit' && (
            <React.Fragment>
              <FlexWrapper justifyContent="space-between" alignItems="center" height={'calc(100% - 8.4%)'}>
                <FlexWrapper alignItems="center">
                  {/* <FlexWrapper alignItems="center">
                    <XLText>My Values</XLText>
                  </FlexWrapper> */}
                  <FlexWrapper viewPadding={'2% 0 0 0'} alignItems="center">
                    <DefaultText>What do you care about? Help us help you.</DefaultText>
                  </FlexWrapper>
                  <FlexWrapper viewPadding="7% 0 0 0">
                    <CustomSlider itemWidth={145} numberOfItems={get(valuesData, 'length')} margin="4px 5px">
                      {valuesData.map((item, index) => {
                        const { icon, title, subTitle } = item
                        return (
                          <Card
                            onClick={() => this.setState({ cardIndex: index })}
                            activeValueCard={cardIndex === index}
                            padding="15px"
                            height="170px"
                            forSlick
                            key={index}>
                            <FlexWrapper>
                              <FlexWrapper direction="row" justifyContent="space-between">
                                <Icon icon={icon} />
                                {horizontal[title] ? (
                                  <FlexWrapper direction="row" justifyContent="flex-end">
                                    <CountWrap borderColor={cardIndex !== index ? '#078489' : null}>
                                      {Math.round(horizontal[title] / 10) || 0}
                                    </CountWrap>
                                  </FlexWrapper>
                                ) : (
                                  ''
                                )}
                              </FlexWrapper>
                              <FlexWrapper viewPadding="8px 0 0 0">
                                <DefaultText textTransform="capitalize" color="#124b5f">
                                  {title}
                                </DefaultText>
                                <XMText color="#078489">{subTitle}</XMText>
                              </FlexWrapper>
                            </FlexWrapper>
                            <FlexWrapper viewPadding={'8px 0 0 0'} alignItems="center">
                              <Arrow />
                            </FlexWrapper>
                          </Card>
                        )
                      })}
                    </CustomSlider>
                  </FlexWrapper>
                  <Card margin="8% 0 0 0" padding="8.9%">
                    <DefaultText textTransform="capitalize" color="#124b5f" fontWeight={600}>
                      {cardTitle[cardIndex]}
                    </DefaultText>
                    <StyledSlider
                      min={0}
                      max={10}
                      value={
                        Math.round(get(horizontal, `${cardTitle[cardIndex]}`, 0) / 10) === null
                          ? 0
                          : Math.round(get(horizontal, `${cardTitle[cardIndex]}`, 0) / 10)
                      }
                      horizontalLabels={horizontalLabels}
                      handleLabel={`${Math.round(get(horizontal, cardTitle[cardIndex], 0) / 10)}`}
                      onChange={value => this.handleChangeHorizontal(value, cardTitle[cardIndex])}
                    />
                  </Card>
                </FlexWrapper>
                <FlexWrapper alignItems="center" viewMargin="20px 0 0 0">
                  <Button
                    label="Update"
                    namespace="Update Values"
                    volume="filled"
                    isLoading={isLoading}
                    margin="auto 0 0 0"
                    disabled={!touched.valuesTouched || isLoading}
                    size="small"
                    onClick={() => this.handleMyValues(cardIndex)}
                  />
                </FlexWrapper>
              </FlexWrapper>
            </React.Fragment>
          )}
          {pathname === '/dashboard/dietary-preference' && (
            <React.Fragment>
              <FlexWrapper justifyContent="space-between" alignItems="center" height={'auto'}>
                <FlexWrapper alignItems="center">
                  <FlexWrapper viewPadding={'8% 0 0 0'} alignItems="center" justifyContent="center">
                    <XLText>Dietary Preference</XLText>
                  </FlexWrapper>
                  <FlexWrapper viewPadding={'2% 0 8% 0'} alignItems="center" justifyContent="center">
                    <DefaultText>How do you want to eat?</DefaultText>
                  </FlexWrapper>
                  <FlexModified justifyContent="center" direction="row" flexWrap="wrap" paddingBottom="84px">
                    {dietsData.map((item, index) => {
                      const { diet, description, id } = item
                      return (
                        <Card
                          key={id}
                          circular
                          padding="8px 24px"
                          onClick={() => this.chipHandler(id)}
                          selectedChip={find(selected, value => value === item.id)}>
                          <XMTDFext>
                            {diet} - {description}
                          </XMTDFext>
                        </Card>
                      )
                    })}
                  </FlexModified>
                </FlexWrapper>
                <FlexWrapper
                  direction="row"
                  justifyContent="center"
                  viewMargin="0 0 3% 0"
                  style={{
                    position: 'fixed',
                    bottom: '24px',
                    zIndex: '99999',
                    left: '0'
                  }}>
                  <Button
                    label="Go Back"
                    namespace="Onboarding"
                    margin="0 10px"
                    size="small"
                    type="button"
                    onClick={() => this.props.history.goBack()}
                  />
                  <Button
                    label="Next"
                    namespace="Onboarding"
                    volume="filled"
                    margin="0 10px"
                    isLoading={isLoading}
                    disabled={isLoading}
                    size="small"
                    onClick={() => this.handleDietaryPreference()}
                  />
                </FlexWrapper>
              </FlexWrapper>
            </React.Fragment>
          )}
          {pathname === '/dashboard/dietary-preference/edit' && (
            <React.Fragment>
              <FlexModified justifyContent="center" direction="row" flexWrap="wrap" height="auto">
                {dietsData.map((item, index) => {
                  const { diet, description, id } = item
                  return (
                    <Card
                      key={id}
                      circular
                      padding="8px 24px"
                      onClick={() => this.chipHandler(id)}
                      selectedChip={find(selected, value => value === item.id)}>
                      <XMTDFext>
                        <span style={{ fontWeight: 'bold' }}>{diet}</span> - {description}
                      </XMTDFext>
                    </Card>
                  )
                })}
              </FlexModified>
              <FlexWrapper direction="row" justifyContent="center" viewMargin="auto 0">
                <Button
                  label="Update"
                  namespace="Update Values"
                  volume="filled"
                  margin="0 10px"
                  isLoading={isLoading}
                  disabled={!touched.dietsTouched || isLoading}
                  size="small"
                  onClick={() => this.handleDietaryPreference()}
                />
              </FlexWrapper>
            </React.Fragment>
          )}
          {pathname === '/dashboard/allergies' && (
            <React.Fragment>
              <FlexWrapper alignItems="center" height="calc(100% - 8.4%)">
                <FlexWrapper viewPadding={'8% 0 0 0'} alignItems="center">
                  <XLText>Any allergies?</XLText>
                </FlexWrapper>
                <FlexWrapper viewPadding={'2% 0 8% 0'} alignItems="center">
                  <DefaultText>Let us know!</DefaultText>
                </FlexWrapper>
                <Formik
                  enableReinitialize
                  initialValues={{
                    allergies: []
                  }}
                  onSubmit={val => console.log(val)}
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="allergies"
                        render={({ field }) => (
                          <FlexWrapper
                            justifyContent="center"
                            direction="row"
                            flexWrap="wrap"
                            position="relative"
                            style={{ zIndex: 99999999 }}>
                            <SelectBox
                              cacheOptions
                              defaultOptions={false}
                              loadOptions={this.loadAllergies}
                              isSelected
                              placeholder="Search"
                              // onKeyUp={obj => {
                              //   console.log('obj', obj)
                              // }}
                              onChange={allergies => {
                                this.setState({ allergiesData: [...this.state.allergiesData, allergies] })
                              }}
                            />
                          </FlexWrapper>
                        )}
                      />
                      <FlexModified justifyContent="center" direction="row" flexWrap="wrap" viewPadding="6% 0 0 0">
                        {allergiesData.map((item, index) => {
                          const { allergy, id } = item
                          return (
                            <Card
                              key={id}
                              circular
                              padding="12px"
                              onClick={() => this.allergyChipHandler(id)}
                              selectedChip={find(selectedAllergy, value => value === item.id)}>
                              <DefaultText color="#124b5f">{allergy}</DefaultText>
                            </Card>
                          )
                        })}
                      </FlexModified>
                      <FlexWrapper direction="row" justifyContent="center" viewMargin="auto 0 3%">
                        <Button
                          label="Previous"
                          namespace="Onboarding"
                          margin="0 10px"
                          size="small"
                          type="button"
                          onClick={() => this.props.history.goBack()}
                        />
                        <Button
                          label="Update"
                          namespace="Onboarding"
                          volume="filled"
                          isLoading={isLoading}
                          type="submit"
                          margin="0 10px"
                          disabled={isLoading}
                          size="small"
                          onClick={() => this.handleAllergies()}
                        />
                      </FlexWrapper>
                    </FormikForm>
                  )}
                />
              </FlexWrapper>
            </React.Fragment>
          )}
          {pathname === '/dashboard/allergies/edit' && (
            <React.Fragment>
              <FlexWrapper alignItems="center" height={'calc(100% - 8.4%)'}>
                {/* <FlexWrapper alignItems="center">
                  <XLText>Any allergies?</XLText>
                </FlexWrapper> */}
                <FlexWrapper viewPadding={'2% 0 8% 0'} alignItems="center">
                  <DefaultText>Let us know!</DefaultText>
                </FlexWrapper>
                <Formik
                  enableReinitialize
                  initialValues={{
                    allergies: []
                  }}
                  onSubmit={val => console.log(val)}
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="allergies"
                        render={({ field }) => (
                          <FlexWrapper
                            justifyContent="center"
                            direction="row"
                            flexWrap="wrap"
                            position="relative"
                            style={{ zIndex: 99999999 }}>
                            <SelectBox
                              cacheOptions
                              defaultOptions={false}
                              loadOptions={this.loadAllergies}
                              isSelected
                              placeholder="Search"
                              onChange={allergies => {
                                ;[allergies].map(item => ({}))
                                this.setState({ allergiesData: [...this.state.allergiesData, allergies] })
                              }}
                            />
                          </FlexWrapper>
                        )}
                      />
                      <FlexModified justifyContent="center" direction="row" flexWrap="wrap" viewPadding="6% 0 0 0">
                        {allergiesData.map((item, index) => {
                          const { allergy, id } = item
                          return (
                            <Card
                              key={id}
                              circular
                              padding="12px"
                              onClick={() => this.allergyChipHandler(id)}
                              selectedChip={find(selectedAllergy, value => value === item.id)}>
                              <DefaultText color="#124b5f">{allergy}</DefaultText>
                            </Card>
                          )
                        })}
                      </FlexModified>
                      <FlexWrapper direction="row" justifyContent="center" viewMargin="auto 0 0 0">
                        <Button
                          label="Update"
                          namespace="Update Values"
                          volume="filled"
                          isLoading={isLoading}
                          type="submit"
                          margin="0 10px"
                          disabled={!touched.allegiesTouched || isLoading}
                          size="small"
                          onClick={() => this.handleAllergies()}
                        />
                      </FlexWrapper>
                    </FormikForm>
                  )}
                />
              </FlexWrapper>
            </React.Fragment>
          )}
          {pathname === '/dashboard/zipcode/edit' && (
            <React.Fragment>
              <FlexWrapper alignItems="center" height={'calc(100% - 8.4%)'}>
                <FlexWrapper viewPadding={'0 0 4% 0'} alignItems="center">
                  <XLText>What's your zip code?</XLText>
                </FlexWrapper>
                <Formik
                  enableReinitialize
                  initialValues={{
                    zipcode: zipcode === 'null' ? '' : zipcode
                  }}
                  validateOnChange
                  validate={zipCodeValidator}
                  onSubmit={values => this.handleZipcode(values)}
                  render={formikBag => (
                    <FormikForm>
                      <Field
                        name="zipcode"
                        render={({ field }) => (
                          <FlexWrapper viewMargin="16px 0 0 0" height="100%">
                            <Input
                              {...field}
                              maxLength={5}
                              placeholder="Enter zip code"
                              styleType="select"
                              error={formikBag.errors.zipcode || error}
                              autoComplete="off"
                              textInput
                              onKeyUp={async () => {
                                this.setState({ touched: { ...this.state.touched, zipCodeTouched: true } })
                                const query = {
                                  filter: {
                                    where: {
                                      zipCode: formikBag.values.zipcode
                                    }
                                  }
                                }
                                if (isEmpty(formikBag.errors) && formikBag.values.zipcode.length >= 4) {
                                  try {
                                    await axios.get(`${API_URL}/ProductCosts/findOne?${qs.stringify(query)}`)
                                    this.setState({ error: '' })
                                  } catch (error) {
                                    this.setState({
                                      error:
                                        'We\'re sorry, we don\'t currently cover your zip code. However, you can still use the app to learn more about your groceries!'
                                    })
                                  }
                                }
                              }}
                            />
                          </FlexWrapper>
                        )}
                      />

                      <React.Fragment>
                        <FlexWrapper
                          direction="row"
                          viewPadding="15px 0 0 0"
                          justifyContent="center"
                          viewMargin="auto 0 0 0">
                          <Button
                            type="submit"
                            label="Update"
                            namespace="Update Values"
                            volume="filled"
                            isLoading={isLoading}
                            disabled={isLoading || (formikBag.values.zipcode === '' && true) || !touched.zipCodeTouched}
                            margin="0 10px"
                            size="small"
                          />
                        </FlexWrapper>
                      </React.Fragment>
                    </FormikForm>
                  )}
                />
              </FlexWrapper>
            </React.Fragment>
          )}
          {pathname === '/dashboard/shop/edit' && (
            <FlexWrapper justifyContent="space-between" alignItems="center" height={'calc(100% - 8.4%)'}>
              <FlexModified justifyContent="center" direction="row" flexWrap="wrap">
                {shops.map((item, index) => {
                  const { storeName, imageUrl } = item
                  return (
                    <Card
                      key={storeName}
                      padding="16px"
                      circular
                      margin="0 8px 8px 0 !important"
                      onClick={() => this.shopsChipHandler(storeName)}
                      bordered={find(selectedShops, value => value === storeName)}>
                      <StyledImage src={imageUrl} alt={storeName} height="42px" maxWidth="60px" />
                    </Card>
                  )
                })}
              </FlexModified>
              <FlexWrapper direction="row" justifyContent="center" viewMargin="auto 0 0 0">
                <Button
                  label="Update"
                  namespace="Update Values"
                  isLoading={isLoading}
                  disabled={isLoading || (selectedShops.length <= 0 && true) || !touched.shopsTouched}
                  volume={selectedShops.length > 0 && 'filled'}
                  margin="0 10px"
                  size="small"
                  onClick={() => this.handleShops()}
                />
              </FlexWrapper>
            </FlexWrapper>
          )}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js